/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { wordTimingSchema } from '../shared/word-timing-schema';

export const getDefinitionAudioV2ResultSchema = z.object({
  audioUrl: z.string(),
  wordTimings: z.array(wordTimingSchema).optional(),
});

export type IGetDefinitionAudioV2Result = z.infer<typeof getDefinitionAudioV2ResultSchema>;

export const getDefinitionAudioV2ResponseSchema = createApiResponseSchema(
  getDefinitionAudioV2ResultSchema,
) as z.ZodSchema<IAPI<IGetDefinitionAudioV2Result>>;

export type IGetDefinitionAudioV2Response = IAPI<IGetDefinitionAudioV2Result>;
